/**
 * Package-wide constants for the global-sso-banner package
 */

// Analytics category used across all components in this package
export const ANALYTICS_CATEGORY = 'global_sso_banner'

// Banner display configuration
export const MAX_DISPLAYED_ORGS = 3

// Cookie configuration
export const COOKIE_NAME = 'dismissed_sso_orgs'
